// extracted by mini-css-extract-plugin
export default {"root":"CoursePausePendingRequestsTable_root__wNfn3","rows":"CoursePausePendingRequestsTable_rows__G2DHo","pagination":"CoursePausePendingRequestsTable_pagination__a+cl4"};